import { createReducer, on } from '@ngrx/store';

import { LOCAL_VARS } from '../../../common/constants/routes.constant';
import { PSL } from '../../../common/models/master-data/psl';
import { IUserSetting } from '../../../common/models/workflow/user-setting';
import {
  PSLActions,
  PSLAPIActions,
  UoMSettingAPIActions,
} from '../actions/user-profile.actions';

export interface UserProfileState {
  userInformation: string;
  chosenPSL?: PSL;
  availablePSLs: PSL[];
  uomSetting?: IUserSetting;

  error?: unknown; // Add error property
}

const initialtState: UserProfileState = {
  userInformation: '',
  availablePSLs: [],
  error: undefined,
};

export const userProfileReducer = createReducer(
  initialtState,
  // PSL Selection Actions
  on(PSLActions.setCurrentPSL, (state, { psl }) => {
    const localStoragePSL = localStorage.getItem(LOCAL_VARS.SelectedPSL);
    const currentPSL: PSL = JSON.parse(localStoragePSL || '{}');

    localStorage.setItem(
      LOCAL_VARS.SelectedPSL,
      JSON.stringify({
        name: psl?.name || currentPSL?.name,
        id: psl?.id || currentPSL?.id,
        code: psl?.code || currentPSL?.code,
      }),
    );

    return {
      ...state,
      chosenPSL: psl ?? currentPSL,
      error: null,
    };
  }),

  on(PSLActions.getLocalStoragePSL, (state) => {
    const localStoragePSL = localStorage.getItem(LOCAL_VARS.SelectedPSL);
    const psl: PSL = JSON.parse(localStoragePSL || '{}');
    return {
      ...state,
      chosenPSL: psl,
      error: null,
    };
  }),

  on(PSLAPIActions.getPSLBySessionSuccess, (state, { psl }) => {
    localStorage.setItem(
      LOCAL_VARS.SelectedPSL,
      JSON.stringify({ name: psl.name, id: psl.id, code: psl.code }),
    );
    return {
      ...state,
      chosenPSL: psl,
      error: null,
    };
  }),

  on(PSLAPIActions.getPSLBySessionFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(PSLAPIActions.getCurrentPSLSuccess, (state, { psl }) => ({
    ...state,
    chosenPSL: psl,
    error: null,
  })),

  on(PSLAPIActions.getCurrentPSLFailure, (state, { error }) => ({
    ...state,
    chosenPSL: undefined,
    error,
  })),

  on(PSLAPIActions.getAvailablePSLsSuccess, (state, { psls }) => ({
    ...state,
    availablePSLs: psls,
    error: null,
  })),

  on(PSLAPIActions.setPSLLoadingState, (state) => ({
    ...state,
    chosenPSL: undefined,
    error: null,
  })),

  on(PSLAPIActions.requestFailure, (state, { error }) => {
    return { ...state, error };
  }),

  // UoM Setting Actions
  on(UoMSettingAPIActions.loadUoMSettingSuccess, (state, { uomSetting }) => {
    return {
      ...state,
      uomSetting,
      error: null,
    };
  }),

  on(UoMSettingAPIActions.applyUoMSettingSuccess, (state, { uomSetting }) => ({
    ...state,
    uomSetting,
    error: null,
  })),

  on(UoMSettingAPIActions.requestFailure, (state, { error }) => {
    return { ...state, error };
  }),
);
